<template>
  <div>  
    <div class="d-flex flex-stack flex-wrap">
      <div class="page-title d-flex flex-column me-3 mt-3"> 
          <h1 class="d-flex text-gray-800 fw-bolder my-1 fs-3">
            Default Company Tasks
          </h1>  
          <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
              <li class="breadcrumb-item text-gray-600">
                  <a href="#" class="text-gray-600 text-hover-primary"><router-link :to="{ name: 'Home' }">Home</router-link></a>
              </li> 
              <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'Settings' }">Settings</router-link></li>  
              <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'GeneralSettings' }">General Settings</router-link></li>
              <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'CompanyManagement' }">Company Management</router-link></li>
              <li class="breadcrumb-item text-gray-600">Default Company Tasks</li> 
          </ul> 
      </div> 
      <div class="d-flex align-items-center py-1">
            <router-link :to="{ name: 'CompanyManagement', params: { type: 'CompanyManagement' } }">
              <button type="button" class="btn btn-light shadow-sm btn-arrow-left border border-gray-400 me-3">
                  <span class="ms-2 fs-7"> Return back to Settings </span>
              </button>
          </router-link>
      </div>  
  </div>  
  <div class="content flex-row-fluid mt-4" id="kt_content">
      <div class="card">
          <div class="card-header border-0">                 
            <div class="row col-lg-6 p-5">
                <div class="fv-row row">
                    <div class="col-lg-8">
                        <label class="fs-6 fw-bold form-label mt-3">
                            <span>Company Types</span>
                        </label>
                        <Select2 v-model="form.company_type_id" :options="companyTypes" :settings="{width: '100%'}" @select="getData()" />
                    </div>
                </div>
            </div>
          </div>
          <div class="card-body pt-0">
              <div class="col-lg-12">
                <div class="p-5">
                    <div class="d-flex flex-stack flex-wrap mb-5">
                        <div class="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
                            <button type="button" class="btn btn-sm btn-light btn-active-success me-3" data-bs-toggle="modal" data-bs-target="#addtasktypemodal" @click="openTaskTypeSelectionModal()"
                              v-if="this.form.company_type_id !== '-1'">
                                <span class="svg-icon svg-icon-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none">
                                        <rect opacity="0.5" x="11.364" y="20.364" width="16" height="2" rx="1"
                                            transform="rotate(-90 11.364 20.364)" fill="currentColor"></rect>
                                        <rect x="4.36396" y="11.364" width="16" height="2" rx="1"
                                            fill="currentColor">
                                        </rect>
                                    </svg>
                                </span>
                                Select New Task
                            </button>
                            <button type="button" class="btn btn-sm btn-light btn-active-warning me-3" @click="deleteType()" :disabled="isItemButtonDisabled == null || isItemButtonDisabled == undefined">
                                <span class="svg-icon svg-icon-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                                    </svg>
                                </span>
                                Remove
                            </button>
                            <button type="button" class="btn btn-sm btn btn-light btn-active-danger me-3" @click="deleteAllTypes()" :disabled="this.lists.length == 0">
                                <span class="svg-icon svg-icon-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                                    </svg>
                                </span>
                                Remove All (!)
                            </button>
                        </div>
                    </div>
                    <div id="kt_datatable_example_1_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                        <div class="table-responsive min-h-300px">                            
                          <DxDataGrid :show-borders="true" 
                                  key-expr="code" 
                                  :data-source="lists" 
                                  :allow-column-reordering="true"  
                                  :allow-column-resizing="true" 
                                  :column-auto-width="true" 
                                  :row-alternatin-enabled="true"
                                  :hover-state-enabled="true" 
                                  :show-row-lines="true" 
                                  @exporting="this.$onExporting($event , 'Default-Company-Tasks-List')">

                                  <DxFilterRow :visible="true"/>
                                  <DxHeaderFilter :visible="true"/>
                                  <DxGroupPanel :visible="true"/>      
                                  <DxExport :enabled="true" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                                  <DxPaging :page-size="20"/>
                                  <DxPager :visible="true" :allowed-page-sizes="pageSizes" :show-page-size-selector="true" :show-info="true" :show-navigation-buttons="true"/> 
                                  <DxSearchPanel :visible="true"/>
                                  
                                  <DxColumn data-field="isSelected" caption="#" :allow-filtering="false" alignment="center" cell-template="is-selected-cell-template" :allow-exporting="false"/>
                                  <DxColumn data-field="code" caption="Code" cell-template="code-cell-template"/> 
                                  <DxColumn data-field="name" caption="Name" cell-template="name-cell-template"/> 
                                  <DxColumn data-field="task_group_category_name" caption="Category" cell-template="task_group_category_name-cell-template"/> 
                                  <DxColumn data-field="task_group_name" caption="Group"  cell-template="task_group_name-cell-template"/> 
                                  <DxColumn data-field="priority_name" caption="Priority" alignment="center" cell-template="priority-cell-template"/>
                                  <DxColumn data-field="period_type_name" caption="Period Type" alignment="center" header-cell-template="period-type-header" cell-template="period_type-cell-template"/>  
                                  <DxColumn data-field="amount_type" caption="Amount" alignment="right" cell-template="amount_type-cell-template"/> 
                                  <DxColumn data-field="hide" caption="Is Hide?" alignment="center" cell-template="hide-cell-template" :allow-filtering="false"/> 
                                  <DxColumn data-field="main_task_type_name" caption="Main Task Type" header-cell-template="main-task-type-header" cell-template="main_task_type_name-cell-template"/>
                                  <DxColumn data-field="auth_type" caption="Authorized User" header-cell-template="authorized-user-header" cell-template="authorized_user-cell-template"/>  
                                  

                                  <!-- Header Cell Templates -->
                                  <template #authorized-user-header>
                                      <div> Authorized </div> <div> User </div>
                                  </template> 
                                  <template #main-task-type-header>
                                      <div> Main </div> <div> Task Type </div>
                                  </template>
                                  <template #period-type-header>
                                      <div> Period </div> <div> Type </div>
                                  </template>

                                  <!-- Cell Templates -->
                                  <template #is-selected-cell-template="{ data }"> 
                                      <span>
                                          <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center" v-if="data.data.code !== null && data.data.code !== ''">
                                            <input class="form-check-input" type="checkbox" v-model="data.data.isSelected" @change="this.onSelectItem(data.data)" />
                                          </div>
                                      </span>
                                  </template>
                                  <template #code-cell-template="{ data }">
                                      <a href="#" class="text-gray-900 mb-1">
                                          <span class="badge badge-circle badge-light me-3" v-if="data.data.full_access == 1">
                                              <i class="bi bi-pencil text-gray-900"></i> 
                                          </span> 
                                          {{ data.data.code }}
                                      </a>
                                  </template>
                                  <template #name-cell-template="{ data }">
                                      <a href="#" class="text-gray-900 fw-bold mb-1">
                                          {{ data.data.name }}
                                      </a>
                                  </template>
                                  <template #task_group_category_name-cell-template="{ data }">
                                      <a href="#" class="text-gray-900 fw-bold mb-1">
                                          {{ data.data.task_group_category_name }}
                                      </a>
                                  </template>
                                  <template #task_group_name-cell-template="{ data }">
                                      <a href="#" class="text-gray-900 fw-bold mb-1">
                                          {{ data.data.task_group_name }}
                                      </a>
                                  </template>
                                  <template #priority-cell-template="{ data }">
                                      <a href="#" class="text-gray-900 text-center fw-bold mb-1">
                                          <span :class="data.data.priority == 1 ? 'badge badge-primary' : data.data.priority == 2 ? 'badge badge-success' : 'badge badge-danger'">
                                            {{ data.data.priority_name }}
                                          </span>
                                      </a>
                                  </template>
                                  <template #period_type-cell-template="{ data }">
                                      <a href="#" class="text-gray-900 text-center fw-bold mb-1">
                                          <span class="badge badge-secondary"> {{  data.data.period_type_name }} </span>
                                          <br>
                                          <span class="badge badge-primary mt-3" v-if="data.data.period_type == 1"><small>{{ previewDate(data.data.period_start) }} - {{ previewDate(data.data.period_end) }}</small></span>
                                          <span class="badge badge-primary mt-3" v-if="data.data.period_type == 2"><small>{{ previewHours(data.data.period_daily_start_time) }} - {{ previewHours(data.data.period_daily_end_time) }}</small></span>
                                          <span class="badge badge-primary mt-3" v-if="data.data.period_type == 3">
                                            <small>Every 
                                              <span v-if="data.data.period_weekly_date == 1">Monday,</span>
                                              <span v-if="data.data.period_weekly_date == 2">Tuesday,</span>
                                              <span v-if="data.data.period_weekly_date == 3">Wednesday,</span>
                                              <span v-if="data.data.period_weekly_date == 4">Thursday,</span>
                                              <span v-if="data.data.period_weekly_date == 5">Friday,</span>
                                              <span v-if="data.data.period_weekly_date == 6">Satuday,</span>
                                              <span v-if="data.data.period_weekly_date == 7">Sunday,</span> 
                                              {{ previewHours(data.data.period_daily_start_time) }} - {{ previewHours(data.data.period_daily_end_time) }}
                                            </small>
                                          </span> 
                                          <span class="badge badge-primary mt-3" v-if="data.data.period_type == 4"><small>Every Month's {{ data.data.period_monthly_date }}</small></span> 
                                          <span class="badge badge-primary mt-3" v-if="data.data.period_type == 5"><small>{{ previewAnnualDate(data.data.period_annual_date) }}</small></span>
                                      </a>
                                  </template>
                                  <template #amount_type-cell-template="{ data }">
                                      <a href="#" class="text-gray-900 text-end fw-bold mb-1">
                                          <span v-if="!data.data.amount_type > 0 || !data.data.is_have_value">-</span>
                                          <span class="badge badge-light-info" v-if="data.data.amount_type == 1 && data.data.is_have_value">Free Amount</span>
                                          <span class="badge badge-light-info" v-if="data.data.amount_type == 2 && data.data.is_have_value">Default Amount</span>
                                          <span class="badge badge-light-info" v-if="data.data.amount_type == 3 && data.data.is_have_value">Get Amount from Company</span>
                                          <span class="badge badge-light-info" v-if="data.data.amount_type == 4 && data.data.is_have_value">Get amount from Parent Value</span>
                                          <br>
                                          <h4 class="text mt-4" v-if="data.data.amount_value != 0"> {{ data.data.amount_value }} </h4>
                                      </a>
                                  </template> 
                                  <template #hide-cell-template="{ data }">
                                        <input class="form-check-input" type="checkbox" disabled value="" id="hide" v-model="data.data.hide">
                                  </template>
                                  <template #main_task_type_name-cell-template="{ data }">
                                      <a href="#" class="text-gray-900 mb-1">
                                          <span class="badge badge-light mt-3"> {{ data.data.main_task_type_name }} </span> 
                                      </a>
                                  </template> 
                                  <template #authorized_user-cell-template="{ data }">
                                      <a href="#" class="text-gray-900 mb-1">
                                          {{data.data.auth_type}}
                                      </a>
                                  </template>
                                  
                                  <DxSummary>
                                      <DxTotalItem
                                          column="id"
                                          summary-type="count"
                                          show-in-column="auth_type"
                                      /> 
                                  </DxSummary>
                          </DxDataGrid>
                        </div>
                        <div class="row">
                            <div
                                class="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start">
                                <div class="dataTables_info" id="kt_datatable_example_1_info" role="status"
                                    aria-live="polite">1 records</div>
                            </div>
                        </div>
                    </div>
                </div>        
              </div>
          </div>
      </div> 
  </div>  


  <div class="modal fade" id="addtasktypemodal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="staticBackdropLabel" tabindex="-1" role="dialog" aria-modal="true">
      <div class="modal-dialog modal-xxl modal-dialog-scrollable">
          <div class="modal-content">
              <div class="modal-header">
                  <h5 class="modal-title">Select Task Types</h5>                     
                  <div class="btn btn-icon btn-sm btn-active-icon-primary"
                      data-bs-dismiss="modal" aria-label="Close" ref="closeModal">
                      <span class="svg-icon svg-icon-1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                              viewBox="0 0 24 24" fill="none">
                              <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                                  transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                              <rect x="7.41422" y="6" width="16" height="2" rx="1"
                                  transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                          </svg>
                      </span>
                  </div>
              </div> 
              <div class="modal-body scroll-y pt-1" :class="{'overlay overlay-block': this.isSelectedTaskTypeSaving == true}"> 
                <div class="row pb-5">
                  <div class="col-lg-4">
                      <label class="fs-6 fw-bold form-label mt-3 text-gray-600">
                          <span>Main Task Type</span>
                      </label>
                      <Select2 v-model="modalForm.main_task_type" :options="mainTaskTypes" @select="openTaskTypeSelectionModal()" :settings="{width: '100%'}" />
                  </div>
                  <div class="col-lg-4">
                      <label class="fs-6 fw-bold form-label mt-3 text-gray-600">
                          <span>Task Group</span>
                      </label>
                      <Select2 v-model="modalForm.task_group_id" :options="taskGroups" @select="getTaskTypes()" :settings="{width: '100%'}" />
                  </div>
                  <div class="col-lg-4">
                      <label class="fs-6 fw-bold form-label mt-3 text-gray-600">
                          <span>Country</span>
                      </label>
                      <Select2 v-model="modalForm.country_code" :options="countryList" @select="getTaskTypes()" :settings="{width: '100%'}" />
                  </div>
                  <div class="col-lg-12 gy-5">
                    
                    <DxDataGrid :show-borders="true" 
                            key-expr="id" 
                            :data-source="taskTypeList" 
                            :allow-column-reordering="true"  
                            :allow-column-resizing="true" 
                            :column-auto-width="true" 
                            :row-alternatin-enabled="true"
                            :hover-state-enabled="true" 
                            :show-row-lines="true" 
                            @exporting="this.$onExporting($event , 'Company-Tasks-List')">

                            <DxFilterRow :visible="true"/>
                            <DxHeaderFilter :visible="true"/>
                            <DxGroupPanel :visible="true"/>      
                            <DxExport :enabled="true" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                            <DxPaging :page-size="1000"/>
                            <DxPager :visible="false" :allowed-page-sizes="pageSizes" :show-page-size-selector="true" :show-info="true" :show-navigation-buttons="true"/> 
                            <DxSearchPanel :visible="true"/>
                            
                            <DxColumn data-field="is_selected" caption="" header-cell-template="is-selected-header" cell-template="is_selected-cell-template"/> 
                            <DxColumn data-field="main_task_type_name" caption="Main Task Type" header-cell-template="main-task-type-header" cell-template="main_task_type_name-cell-template"/> 
                            <DxColumn data-field="code" caption="Code" cell-template="code-cell-template"/> 
                            <DxColumn data-field="name" caption="Name" cell-template="name-cell-template"/> 
                            <DxColumn data-field="task_group_category_name" caption="Category" cell-template="task_group_category_name-cell-template"/> 
                            <DxColumn data-field="task_group_name" caption="Group"  cell-template="task_group_name-cell-template"/> 
                            <DxColumn data-field="priority" caption="Priority"  cell-template="priority-cell-template"/>
                            <DxColumn data-field="period_type" caption="Period Type" header-cell-template="period-type-header" cell-template="period_type-cell-template"/>  
                            <DxColumn data-field="country_code" caption="Country" cell-template="country_code-cell-template" :allow-filtering="false" />

                            <!-- Header Cell Templates -->
                            <template #is-selected-header>                                
                              <div class="form-check form-check-sm form-check-custom form-check-solid">
                                  <input class="form-check-input" type="checkbox" v-model="modalForm.isSelectedAll" @change="onSelectAll()"> 
                              </div>
                            </template>
                            <template #main-task-type-header>
                                <div> Main </div> <div> Task Type </div>
                            </template>
                            <template #period-type-header>
                                <div> Period </div> <div> Type </div>
                            </template>

                            <!-- Cell Templates -->
                            <template #is_selected-cell-template="{ data }">                                
                                <div class="form-check form-check-sm form-check-custom form-check-solid">
                                    <input class="form-check-input" type="checkbox" value="" v-model="data.data.isSelected"> 
                                </div>
                            </template>
                            <template #main_task_type_name-cell-template="{ data }">
                                <a href="#" class="text-gray-900 mb-1">
                                    <span class="badge badge-light mt-3" v-if="data.data.main_task_type == 1">System</span>
                                    <span class="badge badge-light mt-3" v-if="data.data.main_task_type == 2">Controller</span>
                                    <span class="badge badge-light mt-3" v-if="data.data.main_task_type == 3">Company</span> 
                                </a>
                            </template>
                            <template #code-cell-template="{ data }">
                                <a href="#" class="text-gray-900 mb-1">
                                    <span class="badge badge-primary badge-circle badge-sm" :style="{ 'background-color': data.data.color }">
                                        <i :class="data.data.icon + ' text-white'"></i>
                                    </span>  
                                    {{ data.data.code }}
                                </a>
                            </template>
                            <template #name-cell-template="{ data }">
                                <a href="#" class="text-gray-900 fw-bold mb-1">
                                    {{ data.data.name }}
                                </a>
                            </template>
                            <template #task_group_category_name-cell-template="{ data }">
                                <a href="#" class="text-gray-900 fw-bold mb-1">
                                    {{ data.data.task_group_category_name }}
                                </a>
                            </template>
                            <template #task_group_name-cell-template="{ data }">
                                <a href="#" class="text-gray-900 fw-bold mb-1">
                                    {{ data.data.task_group_name }}
                                </a>
                            </template>
                            <template #priority-cell-template="{ data }">
                                <a href="#" class="text-gray-900 fw-bold mb-1">
                                    <span class="badge badge-primary" v-if="data.data.priority == 1">Normal</span>
                                    <span class="badge badge-success" v-if="data.data.priority == 2">Low</span>
                                    <span class="badge badge-danger" v-if="data.data.priority == 3">High</span>
                                </a>
                            </template>
                            <template #period_type-cell-template="{ data }">
                                <a href="#" class="text-gray-900 fw-bold mb-1">
                                    <span class="badge badge-secondary" v-if="data.data.period_type == 1">Free Period</span>
                                    <span class="badge badge-secondary" v-if="data.data.period_type == 2">Daily Period</span>
                                    <span class="badge badge-secondary" v-if="data.data.period_type == 3">Weekly Period</span> 
                                    <span class="badge badge-secondary" v-if="data.data.period_type == 4">Monthly Period</span> 
                                    <span class="badge badge-secondary" v-if="data.data.period_type == 5">Annual Period</span> 
                                    <span class="badge badge-secondary" v-if="data.data.period_type == 6">Periodic Period</span> 
                                    <br>
                                    <span class="badge badge-primary mt-3" v-if="data.data.period_type == 1"><small>{{ previewDate(data.data.period_start) }} - {{ previewDate(data.data.period_end) }}</small></span>
                                    <span class="badge badge-primary mt-3" v-if="data.data.period_type == 2"><small>{{ previewHours(data.data.period_daily_start_time) }} - {{ previewHours(data.data.period_daily_end_time) }}</small></span>
                                    <span class="badge badge-primary mt-3" v-if="data.data.period_type == 3">
                                      <small>Every 
                                        <span v-if="data.data.period_weekly_date == 1">Monday,</span>
                                        <span v-if="data.data.period_weekly_date == 2">Tuesday,</span>
                                        <span v-if="data.data.period_weekly_date == 3">Wednesday,</span>
                                        <span v-if="data.data.period_weekly_date == 4">Thursday,</span>
                                        <span v-if="data.data.period_weekly_date == 5">Friday,</span>
                                        <span v-if="data.data.period_weekly_date == 6">Satuday,</span>
                                        <span v-if="data.data.period_weekly_date == 7">Sunday,</span> 
                                        {{ previewHours(data.data.period_daily_start_time) }} - {{ previewHours(data.data.period_daily_end_time) }}
                                      </small>
                                    </span> 
                                    <span class="badge badge-primary mt-3" v-if="data.data.period_type == 4"><small>Every Month's {{ data.data.period_monthly_date }}</small></span> 
                                    <span class="badge badge-primary mt-3" v-if="data.data.period_type == 5"><small>{{ previewAnnualDate(data.data.period_annual_date) }}</small></span>
                                </a>
                            </template>
                            <template #country_code-cell-template="{ data }">
                                <a href="#" class="text-gray-900 mb-1">
                                    {{ data.data.country_code }}
                                </a>
                            </template>
                            
                            <DxSummary>
                                <DxTotalItem
                                    column="id"
                                    summary-type="count"
                                    show-in-column="is_selected"
                                /> 
                            </DxSummary>
                    </DxDataGrid>
                    <!-- <table class="table align-middle table-row-dashed fs-6 dataTable no-footer table-hover"> 
                        <thead class="fs-7 text-gray-400 text-uppercase">
                          <th> 
                            <div class="form-check form-check-sm form-check-custom form-check-solid">
                                <input class="form-check-input" type="checkbox" v-model="modalForm.isSelectedAll" @change="onSelectAll()"> 
                            </div>
                          </th>
                          <th class="mb-2"> Code  </th>
                          <th class="mb-2"> Task Name </th>
                          <th class="mb-2"> Task Group Name </th>
                          <th class="mb-2"> Task Group Category Name </th>
                          <th class="mb-2"> Priority </th>
                          <th class="mb-2"> Main Task Type </th>
                          <th class="mb-2"> Period Type </th>
                          <th class="mb-2"> Country </th>
                        </thead>
                        <tbody class="fw-bold text-gray-600" v-if="taskTypeList"> 
                          <tr v-for="item in taskTypeList" v-bind:key="item">
                                <td>
                                    <div class="form-check form-check-sm form-check-custom form-check-solid">
                                        <input class="form-check-input" type="checkbox" value="" v-model="item.isSelected"> 
                                    </div>
                                </td> 
                                <td class="text-gray-600">
                                    <span class="badge badge-primary badge-circle badge-sm" :style="{ 'background-color': item.color }">
                                        <i :class="item.icon + ' text-white'"></i>
                                    </span>  
                                  <small> {{ item.code }} </small>
                                </td> 
                                <td class="text-gray-800">
                                    <a href="#" class="text-gray-600 text-hover-primary mb-3">
                                      {{ item.name }}
                                    </a>
                                </td> 
                                <td class="text-gray-600">
                                    <a href="#" class="text-gray-600 text-hover-primary mb-3">
                                    <small> {{ item.task_group_name }} </small>
                                    </a>
                                </td>
                                <td class="text-gray-600">
                                    <a href="#" class="text-gray-600 text-hover-primary mb-3">
                                    <small> {{ item.task_group_category_name }} </small>
                                    </a>
                                </td>
                                <td>
                                    <span class="badge badge-primary" v-if="item.priority == 1">Normal</span>
                                    <span class="badge badge-success" v-if="item.priority == 2">Low</span>
                                    <span class="badge badge-danger" v-if="item.priority == 3">High</span> 
                                </td> 
                                <td> 
                                    <span class="badge badge-dark" v-if="item.main_task_type == 1">System</span>
                                    <span class="badge badge-dark" v-if="item.main_task_type == 2">Controller</span>
                                    <span class="badge badge-dark" v-if="item.main_task_type == 3">Company</span> 
                                </td> 
                                <td>
                                    <span class="badge badge-secondary" v-if="item.period_type == 1">Free Period</span>
                                    <span class="badge badge-secondary" v-if="item.period_type == 2">Daily Period</span>
                                    <span class="badge badge-secondary" v-if="item.period_type == 3">Weekly Period</span> 
                                    <span class="badge badge-secondary" v-if="item.period_type == 4">Monthly Period</span> 
                                    <span class="badge badge-secondary" v-if="item.period_type == 5">Annual Period</span> 
                                    <span class="badge badge-secondary" v-if="item.period_type == 6">Periodic Period</span> 
                                </td>   
                                <td>
                                    {{item.country_code}}
                                </td>   
                            </tr> 
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colspan="9"> {{ this.taskTypeList.length }} records </td> 
                          </tr>
                        </tfoot>
                        <tbody v-if="!taskTypeList">
                              <tr>
                                  <td colspan="11">
                                      <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-7 mb-3 mt-4">
                                          <div class="fs-6 text-gray-800 fw-bolder">No results yet.</div>
                                          <div class="fw-bold text-gray-400">Please use "List" button to get the latest data.</div>
                                      </div>
                                  </td>
                              </tr>
                        </tbody>
                    </table> -->
                  </div>
                </div>
                <div class="overlay-layer bg-dark bg-opacity-5" v-if="this.isSelectedTaskTypeSaving == true">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
              </div> 
              <div class="modal-footer"> 
                   <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
                   <button type="button"  class="btn btn-success" @click="saveSelectedTaskTypes()">Add To List</button>
              </div>
          </div>
      </div>
    </div>
  </div> 
</template>
<style scoped>
.mh-300 {
    min-height: 300px;
}
</style>

<script>
// Component Alias: `DCTL001`  
import axios from 'axios' 
 
import moment from 'moment' 
// import Swal from 'sweetalert2';
import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxSummary, DxTotalItem  } from 'devextreme-vue/data-grid';

 
export default {
  name: "DefaultCompanyTasksList",
  components:{
      DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxSummary, DxTotalItem 
  },
  data() {
    return {
      lists: [],
      taskTypeList: [],
      selectedTaskTypes: [],
      searchbar: '',
      companyTypes: [],
      taskGroups: [],
      isListProgressing: false,
      pageSizes: [10, 20, 50, 100, 'all'],
      page_size: 10,
      page: 1,
      form: {
        company_type_id: '-1'
      },
      modalForm: {
        country_code: '-1',
        task_group_id: '-1',
        main_task_type: 0,
        isSelectedAll: false
      },
      countryList: [{id: null, text: 'ALL' }],      
      mainTaskTypes: [ { id: 0, text: 'ALL' }, { id: 1, text: 'System' },{ id: 2, text: 'Controller' }, { id: 3, text: 'Company' }],
      isSelectedTaskTypeSaving: false
    };
  },
  computed: {
    searchableList() {
      return this.lists.filter(p => { 
        return p.name.toLowerCase().indexOf(this.searchbar.toLowerCase()) != -1;
      });
    },
    previewDate(){
      return (value)=>{
       if (value) {
          return moment(new Date(value)).format('DD.MM.YYYY HH:mm')
        }
      }
    },
    previewAnnualDate(){
      return (value)=>{
       if (value) {
          return moment(new Date(value)).format('MMM Do')
        }
      }
    },
    previewHours(){
       return (value)=>{
       if (value) {
          return moment(new Date(value)).format('HH:mm')
        }
      }
    },
    isItemButtonDisabled() {
      return this.lists.find(item =>item.isSelected == true );
    }
  },
  methods: {
    getData() {
      this.$Progress.start();
      this.lists = [];
      this.isListProgressing = true;
      const parameters = {
        session_id: this.$getUser().session_id,
        company_type_id: this.form.company_type_id
      };  
      axios.post('/api/DefaultCompanyTaskTypes/GetAllDefaultCompanyTaskTypes', parameters, {'Content-Type': 'application/json'})
      .then((response) => { 
        this.lists = response.data;
        this.$Progress.finish();
        setTimeout(() => {
          this.isListProgressing = false;
        }, 500);
      })
      .catch(function (error) {
        console.error(error);
        this.$Progress.finish();
        setTimeout(() => {
          this.isListProgressing = false;
        }, 500);
      });
    },
    getLists() {
      this.$Progress.start();
      this.companyTypes = [];
      const params = {
        session_id: this.$getUser().session_id,
        get_access_status: 0
      };    
      axios.post('/api/CompanyManagement/CompanyTypes', params, {'Content-Type': 'application/json'}).then((companyTypesResponse) => {
        this.companyTypes = companyTypesResponse.data;
        this.companyTypes.unshift({ id: '-1', text: 'Select an option'});
        this.$Progress.finish();
        setTimeout(() => {
          this.isListProgressing = false;
        }, 500);
      })
      .catch(function (error) {
        console.error(error);
        this.$Progress.finish();
        setTimeout(() => {
          this.isListProgressing = false;
        }, 500);
      });
    },
    deleteType() { 
        this.$swal.fire({
          title: 'Are you sure you want to delete this data?',
          confirmButtonColor: '#f1416c',
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: 'Yes',
          icon: 'warning'
        }).then((result) => { 
          if (result.isConfirmed) {            
            this.lists.forEach((item) => {
              if(item.isSelected) {
                const queryParameter = {
                    id: item.default_company_task_type_id,
                    session_id: this.$getUser().session_id,
                };
                axios.post('/api/DefaultCompanyTaskTypes/DeleteDefaultCompanyTaskType', queryParameter, {'Content-Type': 'application/json'})
                .then((response) => { 
                  if(response.data.error == null || response.data.error == 'undefined' || response.data.error == '') { 
                    this.getData();
                  }
                })
                .catch(function (error) {
                    console.error(error);
                });
              }
            });
          }
        })  
      },
      deleteAllTypes() { 
        this.$swal.fire({
          title: 'Are you sure you want to delete this data?',
          confirmButtonColor: '#f1416c',
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: 'Yes',
          icon: 'warning'
        }).then((result) => { 
          if (result.isConfirmed) {            
            const queryParameter = {
              company_type_id: this.form.company_type_id,
              session_id: this.$getUser().session_id,
            };
            axios.post('/api/DefaultCompanyTaskTypes/DeleteDefaultCompanyTaskTypeMulti', queryParameter, {'Content-Type': 'application/json'})
            .then((response) => { 
              if(response.data.error == null || response.data.error == 'undefined' || response.data.error == '') { 
                this.getData();
              }
            })
            .catch(function (error) {
                console.error(error);
            });
          }
        })  
      },
      getTaskTypes(){ 
          // this.$setSessionStorage("record_id", this.form.company_type_id);
          this.$Progress.start();
          this.taskTypeList = [];
          const params = {
            session_id: this.$getUser().session_id,
            get_access_status: 0,
            task_group: this.modalForm.task_group_id,
            country_code: this.modalForm.country_code,
            company_type: this.form.company_type_id,
            main_task_type: this.modalForm.main_task_type
          };
          if (params.country_code == '-1') {params.country_code = null; }
          if (params.task_group == '-1') {params.task_group = null; }
          axios.post("/api/TaskTypes/GetTaskTypesForSelection", params, {'Content-Type': 'application/json'}).then((response) => {  
            this.taskTypeList = response.data.task_types; 
            this.$Progress.finish();
          })
          .catch(function (error) {
            console.error(error); 
            this.$Progress.fail();
          });
      },
      openTaskTypeSelectionModal() {
          this.$Progress.start();
          this.modalForm.country_code = '-1';
          this.modalForm.task_group_id = '-1';
          this.modalForm.isSelectedAll = false;
          this.isSelectedTaskTypeSaving = false;
          const params = {
            session_id : this.$getUser().session_id,
            get_access_status: 0,
            main_task_type: this.modalForm.main_task_type
          };
          axios.post("/api/TaskGroups/GetTaskGroups", params, {'Content-Type': 'application/json'}).then((response) => {
            this.taskGroups = response.data;
            this.taskGroups.unshift({ id: '-1', text: 'ALL'});
            this.taskTypeList = [];
            const parameters = {
              session_id: this.$getUser().session_id,
              get_access_status: 0,
              task_group: this.modalForm.task_group_id,
              country_code: this.modalForm.country_code,
              company_type: this.form.company_type_id,
              main_task_type: this.modalForm.main_task_type
            };
            if (parameters.country_code == '-1') {parameters.country_code = null; }
            if (parameters.task_group == '-1') {parameters.task_group = null; }
            axios.post("/api/TaskTypes/GetTaskTypesForSelection", parameters, {'Content-Type': 'application/json'}).then((response) => {  
              this.taskTypeList = response.data.task_types; 
              this.countryList = response.data.countries; 
              this.countryList.unshift({ id: '-1', text: 'ALL'});
              this.$Progress.finish();
            })
            .catch(function (error) {
              console.error(error); 
              this.$Progress.fail();
            });
          })
          .catch(function (error) {
            console.error(error); 
            this.$Progress.fail();
          });
      },
      saveSelectedTaskTypes(){
        this.isSelectedTaskTypeSaving = true;
        const that = this;
        this.selectedTaskTypes = [];
        this.taskTypeList.forEach((value) => {
          if(value.isSelected){
             this.selectedTaskTypes.push(value.id);
          }
        }); 
        const params = {
          company_type_id: this.form.company_type_id,
          TaskTypes: this.selectedTaskTypes, 
          session_id: this.$getUser().session_id
        };
        axios.post('/api/DefaultCompanyTaskTypes/CreateDefaultCompanyTaskType', params, {'Content-Type': 'application/json'})
          .then((response) => {
              if(response.data.error == null || response.data.error == 'undefined' || response.data.error == '') { 
                this.$swal("Success", "Data saved succesfully..!", 'success');
                this.isSelectedTaskTypeSaving = false;
                this.$refs.closeModal.click();
                this.getData();
              }
              this.isSelectedTaskTypeSaving = false;
          })
          .catch(function (error) {
              this.isSelectedTaskTypeSaving = false;
              console.error(error);
              this.$swal("Failed", "Data could not be saved..Please refresh the page and try again..!", "error"); 
          })
          .finally(function () { 
            setTimeout(() => {
                that.isSelectedTaskTypeSaving = false;
            }, 500);
        });
      },
      onSelectItem(item) {
          this.lists.forEach((value) => {
              if (item.code !== value.code) { 
                  value.isSelected = false;
              }
          });
      },
      onSelectAll() {
        this.taskTypeList.forEach((value) => {
          value.isSelected = this.modalForm.isSelectedAll;
        });
      }
    },
  created() {
    this.getLists();    
  }
}; 
</script>